module.exports = __webpack_public_path__ + "static/media/Kolkata.75ba09d9.jpg";